import { AbgSxProps } from '@abg/typings';

export const avisFirstDeliveryLabelContainer: AbgSxProps = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  paddingInline: '16px',
  paddingBlock: '12px',
  backgroundColor: '#F4F4F4',
  borderBottomLeftRadius: '1px',
  borderBottomRightRadius: '1px',
  marginBottom: '4px',
};
